module.exports = __webpack_public_path__ + "img/icon-crypto-big.4dd37c22.svg";